import React from 'react';
import { getHiddenTicket } from '../../../data/utils/getHiddenTicket';
import { getLabel } from '../../../data/labels';

function IsibetHorseTicketHeader(props) {
	
	const ticketData = props.ticketData;
	const headerData = ticketData.header;
	const conf = props.conf;
	const frontendType = props.frontendType;
	const terminalCopy = props.terminalCopy;
	const printAgainTerminalRec = props.printAgainTerminalRec;
	const skinProperties = props.skinProperties;
	const user = props.user;
	let ticketType = null;
//	if(ticketData.reportType === 1){
//		ticketType = "PSIP";
//	}
//	else if(ticketData.reportType === 15){
//		ticketType = "PSR";
//	}
//	else if(ticketData.reportType === 3){
//		ticketType = "IPP-QF";
//	}
	let palDesc = "";
	let qfDiscl = null;
	
  	if(ticketData.reportType === 1){
		ticketType = "RIV"; // totalizzatore - riversamento
		palDesc = headerData.pal;
	}
	else if(ticketData.reportType === 15){
		ticketType = "NAZ"; // TRIS
		palDesc = "Concorso Ippica Nazionale";
	}
	else if(ticketData.reportType === 3){
		ticketType = "QFI"; // ippica quota fissa
		qfDiscl = ticketData.bet.length === 1? getLabel('printer.plain_ticket.header.single_bets') : getLabel('printer.plain_ticket.header.multiple_bets');
		qfDiscl = qfDiscl + " " + getLabel('printer.plain_ticket.header.fixed_odds');
	}
	
	// this char will be added to the string "ID" (it means identify string of the ticket) to make clear that this receipt has been
	// print again due to technical issues.
	let charPAR = '';
	if(printAgainTerminalRec){
		let idString = getLabel('printer.plain_ticket.header.id');
		idString = idString === '' ? 'IB' : idString;
		charPAR = idString.charAt(idString.length - 1);	
	}
	
	let idTicketToShow = ticketData.idTicket;
	if(terminalCopy && skinProperties && skinProperties.hideTerminalTicket){
		idTicketToShow = getHiddenTicket(idTicketToShow);
	}
		
	const clearBoth = {clear: "both"};
	
	function generateIdTicketWithBars(idTicket){
		let res = '';
		let tokens = idTicket.match(/.{1,4}/g);
		res = tokens.join("-");
		return res;
	}
	
	
	let printShopName = false;

	const mapKey = window.FUNZIONI_TERMINALE? window.FUNZIONI_TERMINALE.NOME_SHOP_SU_RICEVUTA : window.retailFunctions.SHOP_NAME_IN_TICKET;
	printShopName = skinProperties.functions[mapKey];


	let raceTrack = ticketData.raceTrack;
	let raceNr = ticketData.raceNr;
	
	if(!raceTrack){
		if(ticketData.bet && ticketData.bet.length > 0){
			raceTrack = ticketData.bet[0].raceTrack;
		}
		raceTrack = raceTrack? raceTrack : '';
	}
	
	if(!raceNr){
		if(ticketData.bet && ticketData.bet.length > 0){
			raceNr = ticketData.bet[0].raceNr;
		}
		raceNr = raceNr? raceNr : '';
	}
	
	
	return <>
	{
		frontendType === 'SELF-CASHIER' && window.NUM_CASSA && window.NUM_CASSA != 0 && (
			<div>
				<div style={{marginLeft : "30%", fontSize:"15px"}}>{getLabel('retail.cashier_number')}  {window.NUM_CASSA} </div>
			</div>
		)
	}

	
	<div id="header-logos">
		<div id="customer-logo">
		{
			props.customerLogo != null && props.customerLogo.length > 0 && (
					<img src={props.customerLogo} />
			)
			
		}
		</div>
		{
			props.aamsLogo != null &&(
					<div id="aams-logo">
						<img src={props.aamsLogo} />
					</div>
			)
		}
		<div style={clearBoth}></div>
	
	</div>

	
	

	<div id="first-table" style={{fontSize : "10px"}}>
	
		<div>
			<div className="td-100 left"> {getLabel('printer.plain_ticket.header.nc')} : {headerData.nc} </div>
			<div style={clearBoth}></div>
		</div>
		<div>
			<div className="td-25 left">{'FC'} : {headerData.fc} </div>
			<div className="td-25 left">{getLabel('printer.plain_ticket.header.cc')} : {headerData.cc} </div>	
			<div className="td-35 left"> {getLabel('printer.plain_ticket.header.pv')} : {headerData.pv} </div>
			<div className="td-15 left textright"> {getLabel('printer.plain_ticket.header.tm')}: {headerData.tm}</div>
			<div style={clearBoth}></div>
		</div>

		<div>
		
		<div className="td-20 left"> {'AG'}: {headerData.ag}</div> 
		<div className="td-30 left">{getLabel('printer.plain_ticket.header.ge')} : {headerData.ge}</div>
		<div className="td-25 left">{getLabel('printer.plain_ticket.header.oe')} : {headerData.oe}</div>
		<div className="td-25 left">{getLabel('printer.plain_ticket.header.tg')}-{ticketType}</div>
		<div style={clearBoth}></div>
		</div>
		

		<div>
			<div className="td-40 left">{getLabel('printer.plain_ticket.header.id') + charPAR}: {ticketData.idTicket}</div>
			<div className="td-40 left" >{palDesc}</div>
			<div style={clearBoth}></div>
		</div>
	</div>

	{
		ticketData.reportType !== 3 && 
		<div className="textcenter td-100 horseRaceNumber uppercase">{raceTrack + ' ' + raceNr + '° Corsa'}</div>
	}
	
	{
		ticketData.reportType === 15 && <>
			<div className="textcenter td-100 trisDisclam uppercase">{headerData.eventRef}</div>
			<div className="textcenter td-100 palDisclam uppercase">{headerData.eventDetail}</div>
		</>
	}
	{
		ticketData.reportType === 1 && 
		<div className="textcenter td-100 palDisclam uppercase">{"Ippica a riversamento"}</div>
	}
	{
		ticketData.reportType === 3 && 
		<div className="textcenter td-100 palDisclam uppercase">{qfDiscl}</div>
	}
	
	</>
}

export default IsibetHorseTicketHeader;